<template>
    <footer>
        <div id="wrap">
            <!-- 上部分 -->
            <div class="upperPart">
                <div class="upperPart-left">
                    <div class="logo"></div>
                    <div class="contact">
                        <div class="weChat" @click="isShowRrCode = !isShowRrCode"></div>
                        <a
                                href="https://weibo.com/360jishi?topnav=1&wvr=6&topsug=1"
                                target="_blank"
                        >
                            <div class="microBlog"></div>
                        </a>
                        <div class="qrCode" v-show="isShowRrCode"></div>
                    </div>
                    <div class="address">
                        公司地址：北京市区朝阳十里河大羊坊路89号新华国际广场 B座801
                    </div>
                </div>
                <div class="line"></div>
                <div class="upperPart-content footer-public">
                    <div class="title">联系我们</div>
                    <div class="text">客服热线：4001191360</div>
                    <!-- <div class="text">商务合作：zhangxiaoxia-bd@bang.360.cn</div>
                    <div class="text">渠道合作：yeshaofeng@bang.360.cn</div>
                    <div class="text">媒体合作：hanjuntao@bang.360.cn</div>-->
                </div>
                <div class="line"></div>
                <div class="upperPart-right footer-public">
                    <div class="title">办公室地址</div>
                    <div class="text">北京：朝阳区十里河大羊坊路新华国际广场D座801</div>
                    <div class="text">上海：静安区 太阳山路188弄6号302室</div>
                    <div class="text">
                        南京：秦淮区 中山东路300号长发中心B幢(2幢)2206室
                    </div>
                    <div class="text">广州：越秀区 白云路113号白云大厦2607室</div>
                    <div class="text">深圳：福田区 深南中路 统建楼 3栋808</div>
                    <div class="text">成都：青羊区 大墙西街33号鼓楼国际30楼03号</div>
                </div>
            </div>
            <!-- 下部分 -->
            <div class="lowerPart">
                <div>Copyright © 2020-2022 All Rights Reserved 安全中心</div>
                <!-- <div>京ICP备08010314号-19 京公网安备110000000006号</div> -->
                <div>
                    天津奇立软件技术有限公司 · 北京奇立软件技术有限公司
                    <a href="https://beian.miit.gov.cn" target="_blank">{{ recordNo }}</a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        data() {
            return {
                isShowRrCode: true,
            };
        },
        computed: {
            recordNo() {
                var host = window.location.host;
                if (
                    host.indexOf("m.tcbang.cn") !== -1 ||
                    host.indexOf("tcbang.cn") !== -1
                ) {
                    return "京ICP备18004298号-2";
                }

                if (
                    host.indexOf("m.360tcb.com") !== -1 ||
                    host.indexOf("360tcb.com") !== -1
                ) {
                    return "津ICP备20001600号-1";
                } else {
                    return "京ICP备18004298号-2";
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    footer {
        background-color: #092433;
        height: 430px;
        padding: 50px 0;
        box-sizing: border-box;

        #wrap {
            width: 1200px;
            margin: 0 auto;
            // background-color: pink;
            // 上部分
            .upperPart {
                border-bottom: 1px solid #4d5256;
                // padding-bottom: 60px;
                display: flex;
                justify-content: space-between;
                // 竖线
                .line {
                    border-left: 1px solid #4d5256;
                    height: 240px;
                    margin-top: 0px;
                }

                .upperPart-left {
                    .logo {
                        width: 154px;
                        height: 46px;
                        background-image: url("https://p0.ssl.qhimg.com/t01c25ca4ea40464add.png");
                        background-repeat: no-repeat;
                        background-size: auto;
                    }

                    .contact {
                        display: flex;
                        margin: 134px 0 30px 0;
                        position: relative;

                        .weChat,
                        .microBlog {
                            width: 36px;
                            height: 36px;
                            background-repeat: no-repeat;
                            background-size: cover;
                            cursor: pointer;
                        }

                        .weChat {
                            margin-right: 18px;
                            background-image: url("../../assets/imgs/weixin-3.png");
                        }

                        .microBlog {
                            background-image: url("../../assets/imgs/weibo1-copy.png");
                        }

                        .qrCode {
                            transition: all 2s;
                            position: absolute;
                            left: 0;
                            top: -103px;
                            width: 88px;
                            height: 99px;
                            background-image: url("../../assets/imgs/ewm.png");
                        }
                    }

                    .address {
                        max-width: 271px;
                        font-size: 14px;
                        color: #a9b1b6;
                        line-height: 30px;
                    }
                }

                // 公共样式
                .footer-public {
                    margin-top: 5px;

                    .title {
                        color: #ffffff;
                        font-size: 20px;
                    }

                    .text {
                        color: #a9b1b6;
                        font-size: 14px;
                        margin-top: 25px;
                    }
                }
            }

            // 下部分
            .lowerPart {
                display: flex;
                flex-direction: column;
                margin: 0px auto 0;
                color: #a9b1b6;
                font-size: 11px;
                opacity: 0.5;
                align-items: center;

                div:nth-child(2) {
                    margin-top: 10px;

                    a {
                        color: #a9b1b6;
                    }
                }

                div:nth-child(1) {
                    margin-top: 10px;
                }
            }
        }
    }
</style>
